document.addEventListener('DOMContentLoaded', () => {

	const modal = document.getElementById('simple-modal');

	if (!modal) return;

	const titleEl = modal.querySelector('.simple-modal__title');
	const descEl  = modal.querySelector('.simple-modal__desc');
	const iconEl  = modal.querySelector('.simple-modal__icon');

	const closeModal = () => {
		modal.classList.remove('is-open');
		document.body.style.overflow     = '';
		document.body.style.paddingRight = '';

		if (iconEl) {
			iconEl.classList.add('hidden');
			iconEl.classList.remove('flex', 'items-center', 'justify-center');
		}
	};

	modal.querySelectorAll('.js-simple-modal-close')
		 .forEach(el => el.addEventListener('click', closeModal));

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && modal.classList.contains('is-open')) {
			closeModal();
		}
	});

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('.js-simple-modal-open');

		if (!trigger) return;

		event.preventDefault();
		event.stopPropagation();

		const title    = trigger.dataset.title;
		const desc     = trigger.dataset.description;
		const iconHtml = trigger.dataset.iconHtml;

		if (!title && !desc) return;

		titleEl.textContent = title || '';
		descEl.innerHTML    = desc || '';

		if (iconEl) {
			if (iconHtml || trigger.innerHTML) {
				iconEl.innerHTML = iconHtml || `<span class="classified-badges">${trigger.innerHTML}</span>`;

				iconEl.classList.remove('hidden');
				iconEl.classList.add('flex', 'items-center', 'justify-center');
			}
		}

		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

		if (scrollbarWidth > 0) {
			document.body.style.paddingRight = `${scrollbarWidth}px`;
		}

		modal.classList.add('is-open');
		document.body.style.overflow = 'hidden';
	});
});
